module.exports = __webpack_public_path__ + "static/character--keoni-tip@3x.8fe2e867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/character--keoni-tip@3x.png
// module id = 199
// module chunks = 168707334958949